import { Component } from '@angular/core';

@Component({
  selector: 'sb-onboarding-success-page',
  templateUrl: './page.component.html',
  standalone: false, // eslint-disable-line
})
export class OnboardingSuccessPageComponent {}
